document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('options-modal');
  const openBtn = document.getElementById('open-options-modal');

  if (!modal || !openBtn) return;

  // Crear overlay global si no existe
  let overlay = document.getElementById('global-modal-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'global-modal-overlay';
    document.body.appendChild(overlay);
  }

  const originalParent = modal.parentElement;

  function openModal() {
    document.body.appendChild(modal);
    modal.style.display = 'block';
    overlay.style.display = 'block';

    Object.assign(modal.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: '9999',
      maxHeight: '80vh',
      overflowY: 'auto',
      background: '#fff',
      padding: '20px',
      boxShadow: '0 0 15px rgba(0,0,0,0.3)',
      borderRadius: '8px'
    });

    document.body.style.overflow = 'hidden'; // bloquear scroll
  }

  function closeModal() {
    modal.style.display = 'none';
    overlay.style.display = 'none';
    if (originalParent) originalParent.appendChild(modal);
    document.body.style.overflow = ''; // desbloquear scroll
  }

  // Abrir modal con el botón
  openBtn.addEventListener('click', openModal);

  // Cerrar modal al hacer clic en overlay
  overlay.addEventListener('click', closeModal);

  // Cerrar modal con la X
  const closeBtn = modal.querySelector('.close-options-modal');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
});